import { useState } from 'react';

/**
 * useLongPress — fires onLongPress(id) after the user holds a touch/mouse
 * down for `delay` ms without moving or releasing.
 *
 * Usage:
 *   const longPressHandlers = useLongPress(() => onLongPress(id), { disabled });
 *   <div {...longPressHandlers} />
 */
const useLongPress = (callback, { disabled = false, delay = 600 } = {}) => {
  const [timer, setTimer] = useState(null);

  const start = () => {
    if (disabled) return;
    const t = setTimeout(() => {
      callback();
    }, delay);
    setTimer(t);
  };

  const cancel = () => {
    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }
  };

  return {
    onTouchStart: start,
    onTouchEnd:   cancel,
    onTouchMove:  cancel,
    onMouseDown:  start,
    onMouseUp:    cancel,
    onMouseMove:  cancel,
  };
};

export default useLongPress;
